/* eslint-disable */

import DetailsGoogleSheet from "./services/Details/DetailsGoogleSheet";
import DetailsFacebookPixel from "./services/Details/DetailsFacebookPixel";
import DetailsTiktokPixel from "./services/Details/DetailsTiktokPixel";
import DetailsSnapchatPixel from "./services/Details/DetailsSnapchatPixel";
import DetailsGoogleTagManager from "./services/Details/DetailsGoogleTagManager";
import DetailsMicrosoftClarity from "./services/Details/DetailsMicrosoftClarity";
import DetailsFacebookApi from "./services/Details/DetailsFacebookApi";
import DetailsTelegram from "./services/Details/DetailsTelegram";
import DetailsFacebookDomain from "./services/Details/DetailsFacebookDomain";
import DetailsPageSpeak from "./services/Details/DetailsPageSpeak";
import DeatilsAbandonedOrders from "./services/Details/DeatilsAbandonedOrders";
import DetailsUpsell from "./services/Details/DetailsUpsell";
import DetailsConfirmChat from "./services/Details/DetailsConfirmChat";
import DetailsFoorcall from "./services/Details/DetailsFoorcall";
import DetailsEcomanger from "./services/Details/DetailsEcomanger";
import DetailsTrackship from "./services/Details/DetailsTrackship";
import DetailsTiktokConversion from "./services/Details/DetailsTiktokConversion";
import DetailsKeepsafe from "./services/Details/DetailsKeepsafe";
import CloakingCountries from "./services/Details/DetailsCloakingCountrie";
import DetailsOrdersDz from "./services/Details/DetailsOrdersDz";
import DetailsTiktokCatalog from "./services/Details/DetailsFacebookCatalog";
import DetailsSawa9ly from "./services/Details/DetailsSawa9ly";
import DetailsImaginaryDetectionApp from "./services/Details/DetailsimaginaryDetectionApp";
import DetailsFoorchat from "./services/Details/DetailsFoorchat";
import DetailsDigitalProducts from "./services/Details/DetailsDigitalProducts";
import DetailsGoogleSheetV2 from "./services/Details/DeteailsGoogleSheetV2";
import DetailsGoogleSheetV3 from "./services/Details/DetailsGoogleSheetV3";
import DetailsCountrySelector from "./services/Details/DetailsCountrySelector";
import DetailsMssagesEdit from "./services/Details/DetailsMssagesEdit";
import DetailsCrossSell from "./services/Details/DetailsCrossSell";
import DetailsCashBack from "./services/Details/DetailsCashBack";
import DetailsVendex from "./services/Details/DetailsVendex";
import DetailsSmartSuivi from "./services/Details/DetailsSmartSuivi";
import DetailsPrintAgent from "./services/Details/DetailsPrintAgent";
import DetailsOrderExporting from "./services/Details/DetailsOrderExporting";
import { useTranslation } from "react-i18next";

export default function ServiceDetails({ service }) {
  if (!service) return null;
  const { t } = useTranslation();

  const copyToClipboard = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(script)
        .then(() => {
          setButtonText("تم نسخ السكربت");
          setCopySuccess(true);
          setTimeout(() => {
            setButtonText("نسخ السكربت");
            setCopySuccess(false);
          }, 3000);
        })
        .catch((err) => {
          setButtonText("فشل النسخ");
        });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = script;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setButtonText("تم نسخ السكربت");
        setCopySuccess(true);
        setTimeout(() => {
          setButtonText("نسخ السكربت");
          setCopySuccess(false);
        }, 3000);
      } catch (err) {
        setButtonText("فشل النسخ");
      }
      document.body.removeChild(textArea);
    }
  };

  switch (service.id) {
    case "googlesheet":
      return <DetailsGoogleSheet copyToClipboard={copyToClipboard} />;

    case "facebookpixel":
      return <DetailsFacebookPixel />;

    case "tiktokpixel":
      return <DetailsTiktokPixel />;

    case "snapchatpixel":
      return <DetailsSnapchatPixel />;

    case "googletagmanager":
      return <DetailsGoogleTagManager />;

    case "microsoftclarity":
      return <DetailsMicrosoftClarity />;

    case "facebookapi":
      return <DetailsFacebookApi />;

    case "telegram":
      return <DetailsTelegram />;

    case "facebookDomain":
      return <DetailsFacebookDomain />;

    case "pagespeak":
      return <DetailsPageSpeak />;

    case "abandonedOrders":
      return <DeatilsAbandonedOrders />;

    case "upsell":
      return <DetailsUpsell />;

    case "confirmchat":
      return <DetailsConfirmChat />;

    case "foorcall":
      return <DetailsFoorcall />;

    case "ecomanger":
      return <DetailsEcomanger />;

    case "trackship":
      return <DetailsTrackship />;

    case "tiktokaconversion":
      return <DetailsTiktokConversion />;

    case "keepsafe":
      return <DetailsKeepsafe />;

    case "cloakingcountries":
      return <CloakingCountries />;

    case "orderdz":
      return <DetailsOrdersDz />;

    case "digitalProducts":
      return <DetailsDigitalProducts />;

    case "sawa9ly":
      return <DetailsSawa9ly />;

    case "facebookcatalog":
      return <DetailsTiktokCatalog />;

    case "imaginaryDetectionApp":
      return <DetailsImaginaryDetectionApp />;

    case "foorchat":
      return <DetailsFoorchat close={close} />;

    case "googlesheetV2":
      return <DetailsGoogleSheetV2 close={close} />;

    case "googlesheetV3":
      return <DetailsGoogleSheetV3 close={close} />;

    case "CountrySelector":
      return <DetailsCountrySelector close={close} />;

    case "orderMessagesEnabled":
      return <DetailsMssagesEdit close={close} />;

    case "CrossSell":
      return <DetailsCrossSell close={close} />;

    case "CashBack":
      return <DetailsCashBack close={close} />;

    case "Vendex":
      return <DetailsVendex close={close} />;

    case "smartsuivi":
      return <DetailsSmartSuivi />;

    case "printAgent":
      return <DetailsPrintAgent />;

    case "orderExporting":
      return <DetailsOrderExporting />;

    default:
      return (
        <div className="h-[420px] flex flex-col p-4 bg-white dark:!bg-[#181919] rounded-xl shadow-sm">
          <h4 className="font-semibold text-lg text-gray-800 dark:!text-gray-200">
            {t("servicePageDetails.title")}
          </h4>
          <p className="text-gray-600 dark:!text-gray-400 mt-2">
            {t("servicePageDetails.description")}
          </p>
        </div>
      );
  }
}
